import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Record } from '../../core/models/record.model';
import * as RecordActions from './record.actions';

export const recordsFeatureKey = 'records';

export interface RecordState extends EntityState<Record> {
  // additional entities state properties
}

export function sortByCreatedAt(a: Record, b: Record): number {
  return b.createdAt - a.createdAt;
}

export const adapter: EntityAdapter<Record> = createEntityAdapter<Record>({
  sortComparer: sortByCreatedAt,
});

export const initialState: RecordState = adapter.getInitialState({
  // additional entity state properties
});


export const reducer = createReducer(
  initialState,
  on(RecordActions.addRecord,
    (state, action) => adapter.addOne(action.record, state)
  ),
  on(RecordActions.upsertRecord,
    (state, action) => adapter.upsertOne(action.record, state)
  ),
  on(RecordActions.addRecords,
    (state, action) => adapter.addMany(action.records, state)
  ),
  on(RecordActions.upsertRecords,
    (state, action) => adapter.upsertMany(action.records, state)
  ),
  on(RecordActions.updateRecord,
    (state, action) => adapter.updateOne(action.record, state)
  ),
  on(RecordActions.updateRecords,
    (state, action) => adapter.updateMany(action.records, state)
  ),
  on(RecordActions.deleteRecord,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(RecordActions.deleteRecords,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(RecordActions.loadRecords,
    (state, action) => adapter.setAll(action.records, state)
  ),
  on(RecordActions.clearRecords,
    state => adapter.removeAll(state)
  ),
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
